/**
 * HomeLayoutLongForm - Long-form/magazine homepage layout wrapper
 * Applies CSS class for long-form styling; children handle article rendering
 */
import React from 'react';

const HomeLayoutLongForm = ({ children }) => {
    return (
        <div className="home-layout home-layout--long-form">
            <div className="home-layout__body">
                {children}
            </div>
        </div>
    );
};

export default HomeLayoutLongForm;
